import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=5d8fe5ea&scoped=true&"
import script from "./ActivityInfo.vue?vue&type=script&lang=js&"
export * from "./ActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=5d8fe5ea&lang=less&scoped=true&"
import style1 from "./ActivityInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fe5ea",
  null
  
)

export default component.exports